import { rhythm } from 'Themes/typography';
import styled from 'styled-components';

const Body = styled.div`
  padding: ${({ withInnerScroll }) =>
    withInnerScroll ? 0 : `${rhythm(1.5)} ${rhythm(2.5)}`};
`;

export default Body;
